module.exports = __webpack_public_path__ + "img/aea104c.svg";